// Vue
import { Vue, Component, Prop } from "vue-property-decorator";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class StueckzahlInput extends Vue {
  @Prop()
  public biid!: string;
}
